<template>
	<div class="paging">
		<el-pagination background :hide-on-single-page="total<=pageSize" @current-change="handleCurrentChange" :current-page="page" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				
			}
		},
		props: {
			total: {
				type: Number,
				default: 0,
			},
			pageSize: {
				type: Number,
				default: 10
			},
			page:{
				type: Number,
				default: 1,
			}
		},
		mounted() {},
		methods: {
			handleCurrentChange(a) {
				this.$emit('change', a)
			}
		}
	}
</script>
<style>
</style>
